"use client";

import { Header, Footer } from "@/pages/landing/components";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

function AboutUsPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-lavender-light w-full">
      <div
        className={cn(
          "flex flex-col min-h-screen max-w-7xl mx-auto",
          "2k:max-w-[80%]",
          "4k:max-w-[80%]"
        )}
      >
        <Header />
        <main className="px-6 md:px-14 py-12 md:py-20 grow">
          <h1 className="font-h1 mb-8">{t("legal.about.title")}</h1>
          
          <div className="prose prose-neutral max-w-3xl space-y-12">
            <div className="space-y-6">
              <p className="text-xl font-medium text-foreground">
                {t("legal.about.intro")}
              </p>
              <p className="font-body text-muted-foreground whitespace-pre-wrap">
                {t("legal.about.content1")}
              </p>
            </div>

            <blockquote className="border-l-4 border-primary pl-6 italic text-xl md:text-2xl font-serif text-foreground py-2">
              {t("legal.about.quote")}
            </blockquote>

            <section>
              <h2 className="font-h3 mb-4">{t("legal.about.sections.experience.title")}</h2>
              <p className="font-body text-muted-foreground whitespace-pre-wrap">
                {t("legal.about.sections.experience.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-4">{t("legal.about.sections.why.title")}</h2>
              <p className="font-body text-muted-foreground whitespace-pre-wrap">
                {t("legal.about.sections.why.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-4">{t("legal.about.sections.future.title")}</h2>
              <p className="font-body text-muted-foreground whitespace-pre-wrap">
                {t("legal.about.sections.future.content")}
              </p>
            </section>

            <div className="pt-8 border-t border-lavender-dark/20">
              <p className="font-bold text-foreground">
                {t("legal.about.closing")}
              </p>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default AboutUsPage;
